<script lang="ts">
  import { Alert } from '$shared/components';
  import { AlertOption } from '$shared/models/AlertOption';
  import { AlertDetailedInfo } from '$shared/models/AlertDetailedInfo';
  import UIErrorMessage from '$shared/constants/UIErrorMessage';

  const MapCustomMessageWithError: ObjectType<string> = {
    'Invalid provider information': UIErrorMessage.ChecklistInfoOutDate
  };

  interface Props {
    error?: AlertDetailedInfo | string;
    isPage?: boolean;
    onrefresh?: () => void;
  }

  let { error = '', isPage = false, onrefresh }: Props = $props();

  let customMessageKey = $derived(Object.keys(MapCustomMessageWithError).find((key) => {
    if (error instanceof AlertDetailedInfo) {
      return error?.messages?.first()?.includes(key);
    }
    return error?.includes(key);
  }));
  let hasCustomMessage = $derived(customMessageKey && !!MapCustomMessageWithError[customMessageKey]);
  let message = $derived((customMessageKey && MapCustomMessageWithError[customMessageKey]) || error || '');

  const onRefresh = (): void => {
    onrefresh?.();
  };
</script>

{#if error}
  <div class="checklist-error-alert" class:page={isPage}>
    <Alert autoScroll maxWidth closable data={message} options={AlertOption.errorAlert()}>
      {#if hasCustomMessage}
        <div class="desc" class:page={isPage}>
          <button class="action" onclick={(e) => { e.preventDefault(); onRefresh(); }}>Refresh the page</button> and try
          again
        </div>
      {/if}
    </Alert>
  </div>
{/if}

<style>
  .checklist-error-alert {
    margin-bottom: 24px;
  }
  .desc.page {
    margin-left: 6px;
  }
  .desc .action {
    color: inherit;
    text-decoration: underline;
  }
  :global(.checklist-error-alert.page .comp-alert) {
    flex-direction: row;
  }
</style>
